import {
  resolveAwardedCardIds,
  type AwardedCardId,
  type ChoiceKey,
} from '@ark/nup-shared';
import choiceGridNvidiaImg from '../assets/rewards/choice-grid-nvidia.png';
import choiceGridBtcImg from '../assets/rewards/choice-grid-btc.png';
import choiceGridVoucherImg from '../assets/rewards/choice-grid-voucher.png';
import choiceGridHsbcImg from '../assets/rewards/choice-grid-hsbc.png';
import choiceConfirmNvidiaImg from '../assets/rewards/choice-confirm-nvidia.png';
import choiceConfirmBtcImg from '../assets/rewards/choice-confirm-btc.png';
import choiceConfirmVoucherImg from '../assets/rewards/choice-confirm-voucher.png';
import choiceConfirmHsbcImg from '../assets/rewards/choice-confirm-hsbc.png';
import choiceWideNvidiaImg from '../assets/rewards/choice-wide-nvidia.png';
import choiceWideBtcImg from '../assets/rewards/choice-wide-btc.png';
import choiceWideVoucherImg from '../assets/rewards/choice-wide-voucher.png';
import choiceWideHsbcImg from '../assets/rewards/choice-wide-hsbc.png';
import pcChoiceGridNvidiaImg from '../assets/rewards/pc-choice-grid-nvidia.png';
import pcChoiceGridBtcImg from '../assets/rewards/pc-choice-grid-btc.png';
import pcChoiceGridVoucherImg from '../assets/rewards/pc-choice-grid-voucher.png';
import pcChoiceGridHsbcImg from '../assets/rewards/pc-choice-grid-hsbc.png';
import choiceGridSelectedImg from '../assets/rewards/choice-grid-selected.png';
import pcChoiceGridSelectedImg from '../assets/rewards/pc-choice-grid-selected.png';
import awardedNvidiaImg from '../assets/rewards/awarded-nvidia.png';
import awardedBtcImg from '../assets/rewards/awarded-btc.png';
import awardedVoucherImg from '../assets/rewards/awarded-voucher.png';
import awardedHsbcImg from '../assets/rewards/awarded-hsbc.png';
import awarded2000Img from '../assets/rewards/awarded-2000.png';
import awarded4000Img from '../assets/rewards/awarded-4000.png';
import awarded8000Img from '../assets/rewards/awarded-8000.png';
import awarded35000Img from '../assets/rewards/awarded-35000.png';
import awarded65000Img from '../assets/rewards/awarded-65000.png';
import awarded100000Img from '../assets/rewards/awarded-100000.png';
import awardedMissedImg from '../assets/rewards/awarded-missed.png';
import voucher2000Img from '../assets/rewards/voucher-2000.png';
import voucher4000Img from '../assets/rewards/voucher-4000.png';
import voucher8000Img from '../assets/rewards/voucher-8000.png';
import voucher35000Img from '../assets/rewards/voucher-35000.png';
import voucher65000Img from '../assets/rewards/voucher-65000.png';
import voucher1000000Img from '../assets/rewards/voucher-1000000.png';
import pcVoucher2000Img from '../assets/rewards/pc-voucher-2000.png';
import pcVoucher4000Img from '../assets/rewards/pc-voucher-4000.png';
import pcVoucher8000Img from '../assets/rewards/pc-voucher-8000.png';
import pcVoucher35000Img from '../assets/rewards/pc-voucher-35000.png';
import pcVoucher65000Img from '../assets/rewards/pc-voucher-65000.png';
import pcVoucher100000Img from '../assets/rewards/pc-voucher-100000.png';
import pcAwardedNvidiaImg from '../assets/rewards/pc-awarded-nvidia.png';
import pcAwardedBtcImg from '../assets/rewards/pc-awarded-btc.png';
import pcAwardedVoucherImg from '../assets/rewards/pc-awarded-voucher.png';
import pcAwardedHsbcImg from '../assets/rewards/pc-awarded-hsbc.png';
import pcAwarded2000Img from '../assets/rewards/pc-awarded-2000.png';
import pcAwarded4000Img from '../assets/rewards/pc-awarded-4000.png';
import pcAwarded8000Img from '../assets/rewards/pc-awarded-8000.png';
import pcAwarded35000Img from '../assets/rewards/pc-awarded-35000.png';
import pcAwarded65000Img from '../assets/rewards/pc-awarded-65000.png';
import pcAwarded100000Img from '../assets/rewards/pc-awarded-100000.png';
import pcAwardedMissedImg from '../assets/rewards/pc-awarded-missed.png';
import enChoiceGridNvidiaImg from '../assets/en/choice-grid-nvidia.png';
import enChoiceGridBtcImg from '../assets/en/choice-grid-btc.png';
import enChoiceGridVoucherImg from '../assets/en/choice-grid-voucher.png';
import enChoiceGridHsbcImg from '../assets/en/choice-grid-hsbc.png';
import enChoiceConfirmNvidiaImg from '../assets/en/choice-confirm-nvidia.png';
import enChoiceConfirmBtcImg from '../assets/en/choice-confirm-btc.png';
import enChoiceConfirmVoucherImg from '../assets/en/choice-confirm-voucher.png';
import enChoiceConfirmHsbcImg from '../assets/en/choice-confirm-hsbc.png';
import enChoiceWideNvidiaImg from '../assets/en/choice-wide-nvidia.png';
import enChoiceWideBtcImg from '../assets/en/choice-wide-btc.png';
import enChoiceWideVoucherImg from '../assets/en/choice-wide-voucher.png';
import enChoiceWideHsbcImg from '../assets/en/choice-wide-hsbc.png';
import enAwardedNvidiaImg from '../assets/en/awarded-nvidia.png';
import enAwardedBtcImg from '../assets/en/awarded-btc.png';
import enAwardedVoucherImg from '../assets/en/awarded-voucher.png';
import enAwardedHsbcImg from '../assets/en/awarded-hsbc.png';
import enAwarded2000Img from '../assets/en/awarded-2000.png';
import enAwarded4000Img from '../assets/en/awarded-4000.png';
import enAwarded8000Img from '../assets/en/awarded-8000.png';
import enAwarded35000Img from '../assets/en/awarded-35000.png';
import enAwarded65000Img from '../assets/en/awarded-65000.png';
import enAwarded100000Img from '../assets/en/awarded-100000.png';
import enVoucher2000Img from '../assets/en/voucher-2000.png';
import enVoucher4000Img from '../assets/en/voucher-4000.png';
import enVoucher8000Img from '../assets/en/voucher-8000.png';
import enVoucher35000Img from '../assets/en/voucher-35000.png';
import enVoucher65000Img from '../assets/en/voucher-65000.png';
import enVoucher1000000Img from '../assets/en/voucher-1000000.png';
import enPcChoiceGridNvidiaImg from '../assets/en/pc-choice-grid-nvidia.png';
import enPcChoiceGridBtcImg from '../assets/en/pc-choice-grid-btc.png';
import enPcChoiceGridVoucherImg from '../assets/en/pc-choice-grid-voucher.png';
import enPcChoiceGridHsbcImg from '../assets/en/pc-choice-grid-hsbc.png';
import enPcVoucher2000Img from '../assets/en/pc-voucher-2000.png';
import enPcVoucher4000Img from '../assets/en/pc-voucher-4000.png';
import enPcVoucher8000Img from '../assets/en/pc-voucher-8000.png';
import enPcVoucher35000Img from '../assets/en/pc-voucher-35000.png';
import enPcVoucher65000Img from '../assets/en/pc-voucher-65000.png';
import enPcVoucher100000Img from '../assets/en/pc-voucher-100000.png';
import enPcAwardedNvidiaImg from '../assets/en/pc-awarded-nvidia.png';
import enPcAwardedBtcImg from '../assets/en/pc-awarded-btc.png';
import enPcAwardedVoucherImg from '../assets/en/pc-awarded-voucher.png';
import enPcAwardedHsbcImg from '../assets/en/pc-awarded-hsbc.png';
import enPcAwarded2000Img from '../assets/en/pc-awarded-2000.png';
import enPcAwarded4000Img from '../assets/en/pc-awarded-4000.png';
import enPcAwarded8000Img from '../assets/en/pc-awarded-8000.png';
import enPcAwarded35000Img from '../assets/en/pc-awarded-35000.png';
import enPcAwarded65000Img from '../assets/en/pc-awarded-65000.png';
import enPcAwarded100000Img from '../assets/en/pc-awarded-100000.png';
import enAwardedMissedImg from '../assets/en/awarded-missed.png';
import enPcAwardedMissedImg from '../assets/en/pc-awarded-missed.png';
import choiceSuccessNvidiaImg from '../assets/choice-success-nvidia.png';
import choiceSuccessBtcImg from '../assets/choice-success-btc.png';
import choiceSuccessVoucherImg from '../assets/choice-success-voucher.png';
import choiceSuccessHsbcImg from '../assets/choice-success-hsbc.png';
import enChoiceSuccessNvidiaImg from '../assets/en/choice-success-nvidia.png';
import enChoiceSuccessBtcImg from '../assets/en/choice-success-btc.png';
import enChoiceSuccessVoucherImg from '../assets/en/choice-success-voucher.png';
import enChoiceSuccessHsbcImg from '../assets/en/choice-success-hsbc.png';
import pcStickyBarImg from '../assets/rewards/pc-sticky-bar.png';
import enPcStickyBarImg from '../assets/en/pc-sticky-bar.png';
import entryBadgeImg from '../assets/rewards/entry-badge.png';
import enEntryBadgeImg from '../assets/en/entry-badge.png';

export type AdvancedTheme = 'gold' | 'dark';
export type AdvancedTierId =
  | '15w'
  | '40w'
  | '100w'
  | '500w'
  | '1000w'
  | '2000w';

export interface ChoiceOption {
  key: ChoiceKey;
  amount: string;
  label: string;
  note?: string;
}

export interface AdvancedTier {
  id: AdvancedTierId;
  threshold: string;
  enThreshold: string;
  theme: AdvancedTheme;
  image: string;
  enImage: string;
  pcImage: string;
  enPcImage: string;
}

export const CHOICE_OPTIONS: readonly ChoiceOption[] = [
  { key: 'nvidia', amount: '$600', label: '英偉達股票*', note: '*' },
  { key: 'btc', amount: '$600', label: '比特幣*', note: '*' },
  { key: 'voucher', amount: '$400', label: '超市禮券' },
  { key: 'hsbc', amount: '$592', label: '匯豐4股', note: '^' },
];

const CHOICE_GRID_IMAGES: Record<ChoiceKey, string> = {
  nvidia: choiceGridNvidiaImg,
  btc: choiceGridBtcImg,
  voucher: choiceGridVoucherImg,
  hsbc: choiceGridHsbcImg,
};

const CHOICE_CONFIRM_IMAGES: Record<ChoiceKey, string> = {
  nvidia: choiceConfirmNvidiaImg,
  btc: choiceConfirmBtcImg,
  voucher: choiceConfirmVoucherImg,
  hsbc: choiceConfirmHsbcImg,
};

const CHOICE_WIDE_IMAGES: Record<ChoiceKey, string> = {
  nvidia: choiceWideNvidiaImg,
  btc: choiceWideBtcImg,
  voucher: choiceWideVoucherImg,
  hsbc: choiceWideHsbcImg,
};

const PC_CHOICE_GRID_IMAGES: Record<ChoiceKey, string> = {
  nvidia: pcChoiceGridNvidiaImg,
  btc: pcChoiceGridBtcImg,
  voucher: pcChoiceGridVoucherImg,
  hsbc: pcChoiceGridHsbcImg,
};

const EN_CHOICE_GRID_IMAGES: Record<ChoiceKey, string> = {
  nvidia: enChoiceGridNvidiaImg,
  btc: enChoiceGridBtcImg,
  voucher: enChoiceGridVoucherImg,
  hsbc: enChoiceGridHsbcImg,
};

const EN_CHOICE_CONFIRM_IMAGES: Record<ChoiceKey, string> = {
  nvidia: enChoiceConfirmNvidiaImg,
  btc: enChoiceConfirmBtcImg,
  voucher: enChoiceConfirmVoucherImg,
  hsbc: enChoiceConfirmHsbcImg,
};

const EN_CHOICE_WIDE_IMAGES: Record<ChoiceKey, string> = {
  nvidia: enChoiceWideNvidiaImg,
  btc: enChoiceWideBtcImg,
  voucher: enChoiceWideVoucherImg,
  hsbc: enChoiceWideHsbcImg,
};

export const ADVANCED_TIERS: readonly AdvancedTier[] = [
  {
    id: '15w',
    threshold: '≥$15萬',
    enThreshold: '≥$150,000',
    theme: 'gold',
    image: voucher2000Img,
    enImage: enVoucher2000Img,
    pcImage: pcVoucher2000Img,
    enPcImage: enPcVoucher2000Img,
  },
  {
    id: '40w',
    threshold: '≥$40萬',
    enThreshold: '≥$400,000',
    theme: 'gold',
    image: voucher4000Img,
    enImage: enVoucher4000Img,
    pcImage: pcVoucher4000Img,
    enPcImage: enPcVoucher4000Img,
  },
  {
    id: '100w',
    threshold: '≥$100萬',
    enThreshold: '≥$1,000,000',
    theme: 'gold',
    image: voucher8000Img,
    enImage: enVoucher8000Img,
    pcImage: pcVoucher8000Img,
    enPcImage: enPcVoucher8000Img,
  },
  {
    id: '500w',
    threshold: '≥$500萬',
    enThreshold: '≥$5,000,000',
    theme: 'gold',
    image: voucher35000Img,
    enImage: enVoucher35000Img,
    pcImage: pcVoucher35000Img,
    enPcImage: enPcVoucher35000Img,
  },
  {
    id: '1000w',
    threshold: '≥$1,000萬',
    enThreshold: '≥$10,000,000',
    theme: 'dark',
    image: voucher65000Img,
    enImage: enVoucher65000Img,
    pcImage: pcVoucher65000Img,
    enPcImage: enPcVoucher65000Img,
  },
  {
    id: '2000w',
    threshold: '≥$2,000萬',
    enThreshold: '≥$20,000,000',
    theme: 'dark',
    image: voucher1000000Img,
    enImage: enVoucher1000000Img,
    pcImage: pcVoucher100000Img,
    enPcImage: enPcVoucher100000Img,
  },
];

const AWARDED_IMAGES: Record<AwardedCardId, string> = {
  nvidia: awardedNvidiaImg,
  btc: awardedBtcImg,
  voucher: awardedVoucherImg,
  hsbc: awardedHsbcImg,
  '2000': awarded2000Img,
  '4000': awarded4000Img,
  '8000': awarded8000Img,
  '35000': awarded35000Img,
  '65000': awarded65000Img,
  '1000000': awarded100000Img,
};

const PC_AWARDED_IMAGES: Record<AwardedCardId, string> = {
  nvidia: pcAwardedNvidiaImg,
  btc: pcAwardedBtcImg,
  voucher: pcAwardedVoucherImg,
  hsbc: pcAwardedHsbcImg,
  '2000': pcAwarded2000Img,
  '4000': pcAwarded4000Img,
  '8000': pcAwarded8000Img,
  '35000': pcAwarded35000Img,
  '65000': pcAwarded65000Img,
  '1000000': pcAwarded100000Img,
};

const EN_AWARDED_IMAGES: Record<AwardedCardId, string> = {
  nvidia: enAwardedNvidiaImg,
  btc: enAwardedBtcImg,
  voucher: enAwardedVoucherImg,
  hsbc: enAwardedHsbcImg,
  '2000': enAwarded2000Img,
  '4000': enAwarded4000Img,
  '8000': enAwarded8000Img,
  '35000': enAwarded35000Img,
  '65000': enAwarded65000Img,
  '1000000': enAwarded100000Img,
};

const EN_PC_CHOICE_GRID_IMAGES: Record<ChoiceKey, string> = {
  nvidia: enPcChoiceGridNvidiaImg,
  btc: enPcChoiceGridBtcImg,
  voucher: enPcChoiceGridVoucherImg,
  hsbc: enPcChoiceGridHsbcImg,
};

const EN_PC_AWARDED_IMAGES: Record<AwardedCardId, string> = {
  nvidia: enPcAwardedNvidiaImg,
  btc: enPcAwardedBtcImg,
  voucher: enPcAwardedVoucherImg,
  hsbc: enPcAwardedHsbcImg,
  '2000': enPcAwarded2000Img,
  '4000': enPcAwarded4000Img,
  '8000': enPcAwarded8000Img,
  '35000': enPcAwarded35000Img,
  '65000': enPcAwarded65000Img,
  '1000000': enPcAwarded100000Img,
};

const CHOICE_SUCCESS_IMAGES: Record<ChoiceKey, string> = {
  nvidia: choiceSuccessNvidiaImg,
  btc: choiceSuccessBtcImg,
  voucher: choiceSuccessVoucherImg,
  hsbc: choiceSuccessHsbcImg,
};

const EN_CHOICE_SUCCESS_IMAGES: Record<ChoiceKey, string> = {
  nvidia: enChoiceSuccessNvidiaImg,
  btc: enChoiceSuccessBtcImg,
  voucher: enChoiceSuccessVoucherImg,
  hsbc: enChoiceSuccessHsbcImg,
};

/** H5/PC 宫格：英文走 en/，PC 英文走 en/pc-choice-grid。 */
export function findChoiceGridImage(
  key: ChoiceKey,
  isPC = false,
  isEn = false,
): string {
  const table = isPC
    ? isEn
      ? EN_PC_CHOICE_GRID_IMAGES
      : PC_CHOICE_GRID_IMAGES
    : isEn
      ? EN_CHOICE_GRID_IMAGES
      : CHOICE_GRID_IMAGES;
  return table[key] || table.nvidia;
}

/** 确认弹窗无独立 PC 切图，H5/PC 共用；英文走 en/。 */
export function findChoiceConfirmImage(key: ChoiceKey, isEn = false): string {
  const table = isEn ? EN_CHOICE_CONFIRM_IMAGES : CHOICE_CONFIRM_IMAGES;
  return table[key] || table.nvidia;
}

/** 已选宽卡无独立 PC 英图，H5/PC 英文都走 en/choice-wide。 */
export function findChoiceWideImage(
  key: ChoiceKey,
  isEn = false,
  _isPC = false,
): string {
  const table = isEn ? EN_CHOICE_WIDE_IMAGES : CHOICE_WIDE_IMAGES;
  return table[key] || table.nvidia;
}

export function findChoiceSelectedImage(isPC = false): string {
  return isPC ? pcChoiceGridSelectedImg : choiceGridSelectedImg;
}

export function findAdvancedTierImage(
  tier: AdvancedTier,
  isPC = false,
  isEn = false,
): string {
  if (isPC) {
    return isEn ? tier.enPcImage : tier.pcImage;
  }
  return isEn ? tier.enImage : tier.image;
}

export function findAdvancedThreshold(
  tier: AdvancedTier,
  isEn = false,
): string {
  return isEn ? tier.enThreshold : tier.threshold;
}

/** 已获得卡列表：≥1 万含 4 选 1，≥15 万再叠加最高现金券。未命中时用「感謝支持」卡。 */
export function findAwardedImages(
  netHkdCents: number | null | undefined,
  choiceKey: ChoiceKey,
  isPC = false,
  isEn = false,
): string[] {
  const ids = resolveAwardedCardIds(netHkdCents, choiceKey);
  if (!ids.length) {
    return [findMissedImage(isPC, isEn)];
  }
  const table = isPC
    ? isEn
      ? EN_PC_AWARDED_IMAGES
      : PC_AWARDED_IMAGES
    : isEn
      ? EN_AWARDED_IMAGES
      : AWARDED_IMAGES;
  return ids.map((id) => table[id]);
}

/** 未达标 / 未获得奖励卡。 */
export function findMissedImage(isPC = false, isEn = false): string {
  if (isPC) {
    return isEn ? enPcAwardedMissedImg : pcAwardedMissedImg;
  }
  return isEn ? enAwardedMissedImg : awardedMissedImg;
}

/** 选择成功整图：英文走 en/choice-success。 */
export function findChoiceSuccessImage(key: ChoiceKey, isEn = false): string {
  const table = isEn ? EN_CHOICE_SUCCESS_IMAGES : CHOICE_SUCCESS_IMAGES;
  return table[key] || table.nvidia;
}

/** PC 吸底栏。 */
export function findPcStickyBar(isEn = false): string {
  return isEn ? enPcStickyBarImg : pcStickyBarImg;
}

/** 入门赏「必得 / Guaranteed」角标。 */
export function findEntryBadge(isEn = false): string {
  return isEn ? enEntryBadgeImg : entryBadgeImg;
}
